const modes = {
  production: true,
  playground: true,
  staging: true,
  testing: true,
} as const;

export const isProdLike = modes[import.meta.env.MODE as keyof typeof modes] === true;
